import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SFLogin from "./component";
import { withRouter } from "react-router";

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = () => ({});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SFLogin)
);
